import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import amzytickLogo from '../../assets/amzyticks_logo.png';

const AuthLoadingScreen = ({
  title = 'Signing you in...',
  subtitle = 'Preparing your billing terminal',
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        height: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(145deg, #3730A3 0%, #4F46E5 55%, #4338CA 100%)',
        px: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: '#FFFFFF',
          borderRadius: 3,
          border: '1px solid #E2E8F0',
          boxShadow: '0 16px 48px rgba(0,0,0,0.22)',
          py: 4,
          px: 3,
          textAlign: 'center',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img
            src={amzytickLogo}
            alt="Amzyticks"
            style={{ width: 160, height: 'auto', display: 'block' }}
          />
        </Box>

        <CircularProgress size={28} sx={{ color: '#4F46E5', mb: 1.5 }} />

        <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#1E293B', mb: 0.5 }}>
          {title}
        </Typography>

        <Typography sx={{ fontSize: '0.82rem', color: '#64748B' }}>
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthLoadingScreen;
